<template>
  <transition
      name="fade"
      mode="out-in"
      appear
      :duration="500"
  >
    <div
        class="tab-content"
        :class="{active: isActive}"
        v-show="isActive"
    >
      <slot></slot>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    name: {
      required: false
    },
    selected: {
      default: false
    }
  },
  data () {
    return {
      isActive: false
    }
  },
  mounted () {
    this.isActive = this.selected
  },
  watch: {
    isActive (active) {
      if (active)
        this.$parent.moveIndicatorToActive()
    }
  }
}
</script>
